
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface SkillFilterProps {
  skillFilter: string;
  onSkillChange: (value: string) => void;
  uniqueSkills?: string[];
}

export function SkillFilter({
  skillFilter,
  uniqueSkills,
  onSkillChange,
}: SkillFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Skills</Label>
      <Select value={skillFilter} onValueChange={onSkillChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select skill" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All skills</SelectItem>
          {uniqueSkills?.map(
            (skill) =>
              skill && (
                <SelectItem key={skill} value={skill} className="text-foreground hover:bg-accent">
                  {skill}
                </SelectItem>
              )
          )}
        </SelectContent>
      </Select>
    </div>
  );
}
